// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentsGiftSubscription__container","content":"PaymentsGiftSubscription__content","button":"PaymentsGiftSubscription__button"};